"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useState, useEffect } from "react";
import axios from "axios";
export function useCalendlyEvents({ user, access_token }) {
  const [isLoading, setIsLoading] = useState(true);
  const [events, setEvents] = useState([]);
  useEffect(() => {
    if (events.length) return setIsLoading(false);
    (() => __async(this, null, function* () {
      setIsLoading(true);
      try {
        const { data } = yield axios.get(`https://api.calendly.com/event_types?user=${user}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${access_token}` }
        });
        setEvents(data.collection.filter((event) => event.active));
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }))();
  }, [user, access_token, events.length]);
  return { isLoading, events, setEvents };
}
